export default __webpack_public_path__ + "static/lipner-4a932e8be8ab916e3104374b275c8466.jpg";